import { REACT_QUERY_KEYS } from '@/constants'

export const configQueryKeys = {
  all: [REACT_QUERY_KEYS.CONFIG] as const,
  truckClasses: () => [...configQueryKeys.all, 'truckClasses'] as const,
  truckTypes: () => [...configQueryKeys.all, 'truckTypes'] as const,
  sites: (dcId?: number) => ['sites', dcId ?? 'all'],
  sitesWithArea: (
    dcId?: number,
    areaId?: number | null | undefined,
    tourId?: number,
    filterOptions?: {
      shippingDate?: string
      siteType?: 'origin' | 'destination'
      customerId?: number
    }
  ) =>
    [
      'sitesWithArea',
      dcId ?? 'all',
      areaId ?? null,
      tourId ?? null,
      filterOptions ?? null
    ] as const,
  dcs: () => [...configQueryKeys.all, 'dcs'] as const,
  areas: () => [...configQueryKeys.all, 'areas'] as const,
  dcToUsers: (dcId?: number) =>
    [...configQueryKeys.all, 'dcToUsers', dcId ?? 'all'] as const,
  partnerToUsers: (partnerId?: number) =>
    [...configQueryKeys.all, 'partnerToUsers', partnerId ?? 'all'] as const
}
